<template>
    <td-dialog :title="$t(title)" :before-close="dlalogMsgClose" :visible="isMsgAvailable" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-tag type="success" solt="dataTips" style="float:right;margin-top:10px;" v-if="showMaxLimit"
            >{{ $t('pgCommon.IMPORT_ERROR_TOTAL') }}{{ totalCount }}{{ $t('common.NUMBER_COUNT') }},{{ $t('pgCommon.VIEW_ONE_THOUSAND') }}</el-tag
        >
        <el-form>
            <td-table :columns="columns" :height="400" :dataSource="tableData" :hasPage="false" :hasMutiSelect="false" ref="listMessage"></td-table>
        </el-form>
        <span slot="footer">
            <td-button @click="dlalogMsgClose">{{ $t('common.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    components: {},
    props: {
        title: {
            type: [String, Number]
        },
        // 页面是否显示
        isMsgAvailable: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },
    mounted() {},
    data() {
        return {
            columns: [
                {
                    prop: 'sName',
                    label: 'pgCommon.NAME',
                    tableWidth: '200'
                },
                {
                    prop: 'sValue',
                    label: 'pgCommon.VALUE',
                    align: 'center',
                    tableWidth: '350'
                },
                {
                    prop: 'errorReason',
                    label: 'pgCommon.ERROR_CAUSE',
                    align: 'center',
                    render: (createElement, params) => {
                        let spanStyle = 'color:#fc1414';
                        if (params.row.message) {
                            spanStyle = 'color:#fc1414';
                        }
                        return createElement('div', [
                            createElement(
                                'span',
                                {
                                    style: spanStyle
                                },
                                params.row.errorReason
                            )
                        ]);
                    }
                }
            ],
            showMaxLimit: false,
            totalCount: 0,
            tableData: []
        };
    },

    methods: {
        setMessage(data) {
            this.totalCount = data.length;
            let viewData = [];
            if (data.length > 1000) {
                for (let i = 0; i < 1000; i++) {
                    viewData.push(data[i]);
                }
                this.showMaxLimit = true;
                this.tableData = viewData;
            } else {
                this.showMaxLimit = false;
                this.tableData = data;
            }
        },

        // 关闭窗口之前需要调用的方法
        dlalogMsgClose() {
            this.tableData = [];
            this.$emit('dlalogMsgClose');
        }
    }
};
</script>
<style></style>
